import React from 'react';
import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LabelledMuiTypography from "../../../../../ui/mui/mui-display-data/LabelledMuiTypography";
import useApiGetSchedaCostoDetail from "./api-hooks/useApiGetSchedaCostoDetail";

interface Props {
    order_id?: number,
}

const SchedaCostoRawMaterialCard = ({order_id: order_id}: Props) => {
    const theme = useTheme();
    const fontSize = 18;


    const {data: detailedObj, isSuccess, isFetched} = useApiGetSchedaCostoDetail(order_id);


    return (
        <>
            <Box component="fieldset" sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '10px',
                backgroundColor: theme.palette.backgroundAppGarageColor.main
            }}>
                <legend style={{
                    padding: '0 8px',
                    color: theme.palette.primary.main,
                    fontWeight: 500
                }}>
                    Materia Prima
                </legend>

                <>
                    <LabelledMuiTypography
                        label={'Totale Pezzi Caricati'}
                        value={detailedObj?.raw_materials_summary?.total_pcs?.toFixed(2)}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Totale Mq Caricati'}
                        value={detailedObj?.raw_materials_summary?.total_sqm?.toFixed(2)}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Costo Costo Materia Prima'}
                        value={detailedObj?.raw_materials_summary?.total_cost?.toFixed(2) + " €" ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />
                    <LabelledMuiTypography
                        label={'Misura iniziale'}
                        value={detailedObj?.misura_iniziale?.toFixed(2) ?? ''}
                        upperCaseValue={true}
                        fontSize={fontSize}
                    />


                </>

            </Box>

        </>
    );
}

export default SchedaCostoRawMaterialCard;